"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cuveglio": {
    "8f536a49": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-boffalora": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "335e8d7f": [{
      "hkey": "408cc8e4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "canonica": [{
      "hkey": "408cc8e4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cuveglio"
    }],
    "681b6234": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "skipSearch": false
    }],
    "casa-bignes": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dd117420": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63b416f8": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "skipSearch": false
    }],
    "marianne": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7fe3f4e5": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-rossel": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7408f454": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "skipSearch": false
    }],
    "sant-anna": [{
      "hkey": "1c15b5e2",
      "slug": "cuveglio",
      "name": "Cuveglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "22b82032": [{
      "hkey": "408cc8e4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "vergobbio": [{
      "hkey": "408cc8e4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cuveglio"
    }]
  }
};
exports["default"] = _default;